import React, {createContext, useCallback, useMemo, useState} from 'react';

export const OnlineOrderContext = createContext();

const normalizeOrderType = (type = '') => {
    const normalizedType = type?.toString?.().trim?.() || '';
    const lowerCasedType = normalizedType.toLowerCase();

    if (!lowerCasedType) {
        return '';
    }

    if (lowerCasedType === 'online') {
        return 'online';
    }

    if (lowerCasedType === 'dinein' || lowerCasedType === 'dine-in' || lowerCasedType === 'dine in') {
        return 'dineIn';
    }

    if (lowerCasedType === 'takeaway' || lowerCasedType === 'take away' || lowerCasedType === 'take-away') {
        return 'takeAway';
    }

    if (normalizedType === 'takeAway' || normalizedType === 'dineIn') {
        return normalizedType;
    }

    return normalizedType;
};

const OnlineOrderProvider = ({ children }) => {
    const [orderType, setOrderType] = useState('');
    const [orderData, setOrderData] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        note: '',
        kitchenNote: '',
        dateTime: new Date(),
        orderType: orderType
    });

    const updateOrderData = useCallback((data, type) => {
        const convertedType = normalizeOrderType(type);
        setOrderData({...data, orderType:convertedType});
        setOrderType(convertedType);
    }, []);

    const resetOnlineOrder = useCallback(() => {
        setOrderType('');
        setOrderData({
            firstName: '',
            lastName: '',
            phoneNumber: '',
            note: '',
            kitchenNote: '',
            dateTime: new Date(),
            orderType: '',
        });
    }, []);

    // Memoize the value: updateOrderData/resetOnlineOrder are useCallback-stable
    // and setOrderData is a stable setter, so the reference only changes when
    // orderData/orderType actually change — sparing all consumers a needless
    // re-render whenever a parent above this provider re-renders.
    const value = useMemo(
        () => ({ orderData, orderType, updateOrderData, resetOnlineOrder, setOrderData }),
        [orderData, orderType, updateOrderData, resetOnlineOrder],
    );

    return (
        <OnlineOrderContext.Provider value={value}>
            {children}
        </OnlineOrderContext.Provider>
    );
};

export default OnlineOrderProvider;
